module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row chat"
  }, [(_vm.messages.length > 0) ? _c('div', {
    staticClass: "column column-70"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message,
      staticClass: "message",
      style: (_vm.parseColor(message.user_color))
    }, [_c('div', {
      staticClass: "time_block"
    }, [_vm._v("\n            " + _vm._s(_vm.parseTime(message.date)) + "\n          ")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(message.body))])])
  }))], 1) : _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.users.length == 1) ? _c('div', [_vm._v("\n        Invite somebody by sending them a link to this page. Remember to tell them what's the password. Otherwise, they won't be able to connect.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Keep in mind that users won't be able to see messeges sent while they were gone.\n      ")]) : _c('div', [_c('br'), _vm._v(" "), _c('b', [_vm._v("Oh! Somebody is here!")]), _vm._v(" Write something, quickly! :)\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "user_count"
  }, [_vm._v("\n        users online: "), _c('b', [_vm._v(_vm._s(_vm.users.length))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    attrs: {
      "maxlength": "240",
      "autofocus": "",
      "placeholder": "(240 characters. Enter sends)",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.sendMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-841ffed4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 174
// module chunks = 2